import { render, staticRenderFns } from "./FormCouponDetail.vue?vue&type=template&id=99d0ccd8&scoped=true&"
import script from "./FormCouponDetail.vue?vue&type=script&lang=js&"
export * from "./FormCouponDetail.vue?vue&type=script&lang=js&"
import style0 from "./FormCouponDetail.vue?vue&type=style&index=0&id=99d0ccd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d0ccd8",
  null
  
)

export default component.exports